import type { WindowLocation } from '@gatsbyjs/reach-router'
import { FC, useContext } from 'react'

import { CartContext } from '../lib/cart'
import { removeDispensaryPrefixAndSlug } from '../lib/dispensaries/utils/dispensaries'

/**
 * Determine if cart should be loaded automatically for specified location. This helps avoid
 * unexpected/unwanted side effects for callback pages (e.g. Truemed success page).
 */
export const UpdateLoadCartAllowed: FC<{ location: WindowLocation }> = ({ location }) => {
  const { allowLoadCart } = useContext(CartContext)

  // avoid evaluating path if cart loading is already allowed
  if (!allowLoadCart) {
    return null
  }

  const normalizedPath = removeDispensaryPrefixAndSlug(location?.pathname ?? '/')
  if (normalizedPath !== '/checkout/truemed/success' && normalizedPath !== '/logging-in') {
    allowLoadCart()
  }

  return null
}
